/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <no-ssr>
    <div class="position-relative">
      <gmap-autocomplete
        class="form-control"
        :class="{'is-invalid': !validState, 'empty': !value}"
        ref="autocompleteController"
        @place_changed="setPlace"
        :placeholder="placeholder"
        autocomplete="off"
        type="text"
        name="street"
        :selectFirstOnEnter="true"
        @input="triggerInput"
        @blur.native="$emit('blur')"
        :componentRestrictions="restriction"
        >
      </gmap-autocomplete>
      <div class="input-bar"></div>
      <label :for="name" :class="[labelClass]" v-html="label"/>
      <b-form-invalid-feedback >
        <!-- This will only be shown if the preceeding input has an invalid state -->
        <div v-for="(validation, index) in validationsFiltered"
          :key="index">
          {{ validation.text }}
        </div>
      </b-form-invalid-feedback>
    </div>
  </no-ssr>
</template>

<script>
import filter from 'lodash/filter'

function tryToWrite ($refs, str) {
  if ($refs.autocompleteController && $refs.autocompleteController.$el) {
    $refs.autocompleteController.$el.value = str
  } else {
    setTimeout(() => {
      tryToWrite($refs, str)
    }, 500)
  }
}
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: () => ''
    },
    label: {
      type: String,
      default: () => ''
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    validations: {
      type: Array,
      default: () => []
    },
    countryAvailable: {
      type: Array,
      default: () => []
    }
  },
  $_veeValidate: {
    value () {
      // used for validation parents
      return this.value
    },
    name () {
      return this.name
    }
  },
  computed: {
    restriction () {
      if (this.countryAvailable.length) {
        return { country: this.countryAvailable.map(item => item.toLowerCase()) }
      }
      return undefined
    },
    validationsFiltered () {
      return filter(this.validations, { condition: true })
    },
    validState () {
      return this.validationsFiltered.length === 0
    }
  },
  watch: {
    value (newValue) {
      tryToWrite(this.$refs, newValue)
    }
  },
  methods: {
    triggerInput (event) {
      this.$emit('input', event.target.value)
    },
    setPlace (place) {
      this.$emit('place_changed', place)
    }
  },
  mounted () {
    tryToWrite(this.$refs, this.value)
  }
}
</script>
